const initConsultation = () => {
  const consultationSection = document.querySelector('.consultation');
  const consultationProgressBar = document.querySelector('.consultation .consultation-progress-bar');
  const consultationAdditionalPanels = document.querySelector('.consultation .additional-panels');
  const consultationSideInfo = document.querySelector('.consultation .side-info');
  //const consultationCloseBtn = document.querySelector('.consultation .consultation-close');
  const consultationCloseBtn = document.querySelector('.header__column_quiz .close-tag');
  const consultationSteps = document.querySelectorAll('.consultation .consultation-step');
  const consultationStepThanks = document.querySelector('.consultation .consultation-step-thanks');
  const consultationNextBtn = document.querySelector('.consultation .consultation-btn');
  const consultationNextBtnMobile = document.querySelector('.consultation .consultation-btn-mobile');
  const consultationPrevBtn = document.querySelector('.consultation .consultation-back');
  const consultationSelectableFields = document.querySelectorAll('.consultation .selectable-field');
  const consultationSelections = document.querySelectorAll('.consultation .consultation-step-icon');
  const consultationHomeSelection = document.querySelector('.consultation .consultation-step-home');
  const consultationConsents = document.querySelectorAll('.consultation .consultation-consent input');
  const consultationPaymentOptions = document.querySelectorAll('.consultation .payment-option');
  const consultationRestartBtn = document.querySelector('.consultation .consultation-restart');
  const consultationRecommentationBtn = document.querySelector('.consultation .recommendation-btn');

  const getClickId = () => {
    try {
      const gcl_obj = JSON.parse(localStorage.getItem('_gcl_ls'));
      return gcl_obj?.gclid?.value?.value || null;
    } catch (error) {
      console.error('Invalid JSON in localStorage', error);
    }
  }

  const getGoogleAdId = (param) => {
    try {
      const stored = localStorage.getItem(param);
      console.log(stored);
      return stored || null;
    } catch (error) {
      console.error('Invalid JSON in localStorage', error);
      return null;
    }
  }

  const getType = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const type = params.get('type');

      return type || 'comprehensive';
    } catch (error) {
      console.error('Invalid param type', error);
    }
  }

  const consultationVersion = () => {
    try {
      let cons_version = null;
      if(consultationSection.id && consultationSection.id == 'consultation-in-section') {
        cons_version = 'Consultation Flow v5';
      } else if (window.location.pathname.indexOf('/book-a-consultation') < 0) {
        if(window.location.search.indexOf('lifestyle=home') > 0) {
          cons_version = 'Consultation Flow v7.home';
        } else {
          cons_version = 'Consultation Flow v7';
        }
        
      } else {
        cons_version = 'Consultation Flow v6';
      }
      return cons_version;
    } catch (error) {
      console.error('Invalid Location Pathname', error);
    }
  }

  const getLifestyle = () => {
    try {
      if(consultationSection.id && consultationSection.id == 'consultation-in-section') {
        return 'roam';
      } else {
        const params = new URLSearchParams(window.location.search);
        const lifestyle = params.get('lifestyle');
        return lifestyle;
      }
      
    } catch (error) {
      console.error('Invalid Lifestyle parameter', error);
    }
  }

  const getWearable = () => {
    try {
      if(consultationSection.id && consultationSection.id == 'consultation-in-section') {
        return 'wrist';

      } else {
        const params = new URLSearchParams(window.location.search);
        const wearable = params.get('wearable');

        if(wearable) {
          consultationProgressBar.querySelector('.round-step:nth-last-child(3)').remove();
          consultationProgressBar.querySelector('.progress-line:nth-last-child(2)').remove();
          console.log(consultationSteps);
          const wearableStep = [...consultationSteps].find(step => step.dataset.tag === 'home_device');
          wearableStep.remove();
        }

        return wearable;
      }

    } catch (error) {
      console.error('Invalid Wearing Position parameter', error);
    }
  }

  if(consultationVersion() == 'Consultation Flow v4' && getLifestyle() == null) {
    // redirect to full flow
    if (!Shopify.designMode) {
      window.location = '/pages/book-a-consultation';
    }
  }

  let consultation_data = {
    id: null,
    first_name: null,
    surname: null,
    relationship: null,
    consent_sms: true,
    consent_email: true,
    email: null,
    phone: null,
    lifestyle: getLifestyle(),
    wearable: getWearable(),
    recommendation: null,
    is_completed: false,
    payment: null,
    information: null,
    version: consultationVersion(),
    type: getType(),
    gclid: getClickId(),
    gbraid: getGoogleAdId('gbraid'),
    wbraid: getGoogleAdId('wbraid'),
    msclkid: getGoogleAdId('msclkid')
  };

  let consultation_results = [];

  if(!consultationSection || !consultationNextBtn) {
    return false;
  }

  const updateProgressBar = (step) => {
    consultationProgressBar.querySelectorAll('.round-step[data-step]').forEach((round_step) => {
      if(step >= Number(round_step.dataset.step)) {
        round_step.classList.add('active');
      } else {
        round_step.classList.remove('active');
      }
    });
  }

  const updateAdditionalPanels = (step) => {
    if(consultationAdditionalPanels) {
      consultationAdditionalPanels.querySelectorAll('.additional-panels-wrapper[data-step]').forEach((panels_step) => {
        if(step == Number(panels_step.dataset.step)) {
          panels_step.classList.add('active');
        } else {
          panels_step.classList.remove('active');
        }
      });
    }
    if(consultationSideInfo) {
      consultationSideInfo.querySelectorAll('.side-info-wrapper[data-step]').forEach((side_step) => {
        if(step == Number(side_step.dataset.step)) {
          side_step.classList.add('active');
        } else {
          side_step.classList.remove('active');
        }
      });
    }
  }

  const closeConsultation = () => {
    let currentStep = consultationSection.querySelector('.consultation-step.active');
    sendConsultationDataLayerEvent(
      parseInt(currentStep),
      'cons_other_event', 
      currentStep.dataset.tag, 
      'Close',
      false,
      false
    );
    if(document.referrer && document.referrer.startsWith(document.location.origin)) {
      document.location = document.referrer;
    } else {
      document.location = document.location.origin;
    }
  }

  const storeSelection = (recommendation) => {
    window.localStorage.setItem('consultation-data', recommendation);
  }

  const storeAdditionalSelection = (consultationDetails) => {
    window.localStorage.setItem('consultation-data-details', consultationDetails);
  }

  const removeStoredSelection = () => {
    window.localStorage.removeItem('consultation-data');
  }

  const getStoredSelection = () => {
    if(window.localStorage.getItem('consultation-data')) {
      return window.localStorage.getItem('consultation-data');
    } else {
      return false;
    }    
  }

  const toggleBackBtn = (toggle) => {
    if(toggle == 'show') {
      //consultationPrevBtn.style.display = 'flex';
      consultationPrevBtn.classList.remove('disabled');
    } else {
      //consultationPrevBtn.style.display = 'none';
      consultationPrevBtn.classList.add('disabled');
    }
  }

  const fadeElementIn = (el) => {
    setTimeout(() => {
        el.style.opacity = 1;
    }, 200);
  }

  const validateStep = () => {
    // check current step has all fields filled and correct
    let error = false;
    let currentStep = consultationSection.querySelector('.consultation-step.active');

    // check selectables
    if(currentStep.querySelectorAll('.selectable-field').length > 0) {
      if(currentStep.querySelectorAll('.selectable-field input[type="radio"]:checked').length == 0){
        error = true;
        currentStep.querySelector('.selectable-field').classList.add('error');
      } else {
        currentStep.querySelector('.selectable-field').classList.remove('error');
        // store relationship
        if(currentStep.querySelector('.selectable-field#relationship-field')) {
          consultation_data.relationship = currentStep.querySelector('.selectable-field#relationship-field input:checked').value;
          if(consultation_data.relationship == 'Myself') {
            consultationSection.classList.add('is-myself-version');
          } else {
            consultationSection.classList.remove('is-myself-version');
          }
        }
      }
    }

    // check text fields
    if(!error && currentStep.querySelectorAll('input.field__input[type="text"]').length > 0) {
      currentStep.querySelectorAll('input.field__input[type="text"]').forEach((input) => {
        if(input.value.trim().length < 2) {
          error = true;
          input.classList.add('error');
        } else {
          input.classList.remove('error');
          // store name & surname
          if(input.name == 'name' || input.name.indexOf('first-name') >= 0 || input.name.indexOf('your-name') >= 0) {
            consultation_data.first_name = input.value;
            consultationSection.querySelectorAll("*").forEach(el => {
              if (el.children.length === 0 && el.textContent.includes("[name]")) {
                el.innerHTML = el.innerHTML.replaceAll(
                  "[name]",
                  `<span class="consultation-username">${consultation_data.first_name}</span>`
                );
              } else if(consultationSection.querySelectorAll('.consultation-username').length > 0) {
                consultationSection.querySelectorAll('.consultation-username').forEach((username) => {
                  username.textContent = consultation_data.first_name;
                });
              }
            });
          } else if(input.name == 'surname' || input.name.indexOf('last-name') >= 0 
                    || input.name.indexOf('second-name') >= 0 || input.name.indexOf('surname') >= 0) {
            consultation_data.surname = input.value;
          }
        }
      });
    }

    // check email fields
    if(!error && currentStep.querySelectorAll('input.field__input[type="email"]').length > 0) {
      const email_regex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
      currentStep.querySelectorAll('input.field__input[type="email"]').forEach((input) => {
        if(input.value.trim() == ''){
          error = true;
          input.classList.add('error');
          input.classList.add('error-empty');
        } else if(!email_regex.test(input.value)) {
          error = true;
          input.classList.add('error');
          input.classList.remove('error-empty');
        } else {
          input.classList.remove('error');
          input.classList.remove('error-empty');
          consultation_data.email = input.value;
        }
      });
    }

    // check phone fields
    if(!error && currentStep.querySelectorAll('input.field__input[type="tel"]').length > 0) {
      const phone_regex = /^(?:\+44\s?7\d{9}|\+44\s?[1-3|8]\d{9,10}|0?7\d{9}|0[1-3|8]\d{9,10})$/; // /^(?:\+44\s?7\d{3}|\+44\s?[1-3|8]\d{3}|0?7\d{9}|0[1-3|8]\d{9,10})(?:[\s-]?\d{3,4})*$/;
      currentStep.querySelectorAll('input.field__input[type="tel"]').forEach((input) => {
        if(input.value.trim() == ''){
          error = true;
          input.classList.add('error');
          input.classList.add('error-empty');
        } else if(!phone_regex.test(input.value.replace(/\s|-/g, ''))) {
          error = true;
          input.classList.add('error');
          input.classList.remove('error-empty');
        } else {
          input.classList.remove('error');
          consultation_data.phone = input.value;
          dataLayer.push({'event': 'generate_lead'});
        }
      });
    }

    // check optionables
    if(!error && currentStep.querySelector('.consultation-step-icons')) {
      if(!currentStep.querySelector('.consultation-step-icons .consultation-step-icon.active') ||
      (currentStep.querySelector('.consultation-step-icons .consultation-step-icon.step-home-trigger.active') && 
      !currentStep.querySelector('.consultation-step-icons .consultation-step-icon.step-home.active'))) {
        error = true;
        currentStep.querySelector('.consultation-step-icons').classList.add('error');
      } else if(currentStep.dataset.tag == 'home_device') {
        // v4 home question
        consultation_data.wearable = currentStep.querySelector('.consultation-step-icons .consultation-step-icon.active').dataset.selection;
        consultation_data.recommendation = getRecommendation();
      } else {
        currentStep.querySelector('.consultation-step-icons').classList.remove('error');

        let step_data = currentStep.querySelector('.consultation-step-icons .consultation-step-icon.active').dataset.selection;

        // version 6
        if(currentStep.dataset.tag == 'Lifestyle') {
          consultation_data.lifestyle = step_data;
        } else if(currentStep.dataset.tag == 'Wearable') {
          consultation_data.lifestyle = step_data.split(',')[0];
          consultation_data.wearable = step_data.split(',')[1];
        }

        if(step_data == 'home') {
          currentStep.nextElementSibling.classList.add('home-option');
        } else {
          currentStep.nextElementSibling.classList.remove('home-option');
        }

        /***************         
        let step_data = currentStep.querySelector('.consultation-step-icons .consultation-step-icon:not(.step-home).active').dataset.selection;
        let step_data_home = currentStep.querySelector('.consultation-step-icons .consultation-step-icon.step-home.active')?.dataset.selection;
        if(step_data.indexOf('roam') >= 0) {
          consultation_data.lifestyle = 'roam';
          currentStep.dataset.lifestyle = 'roam';
          currentStep.dataset.wearable = step_data.split(',')[1];
          consultation_data.wearable = step_data.split(',')[1];
        }
        if(step_data.indexOf('home') >= 0) {
          consultation_data.lifestyle = 'home';
          currentStep.dataset.lifestyle = 'home';
          currentStep.dataset.wearable = step_data_home;
          consultation_data.wearable = step_data_home;
        }
        if(step_data.indexOf('home') >= 0 || step_data.indexOf('roam') >= 0) {
          consultation_data.recommendation = getRecommendation();
        }
        */
      }
    }

    return error ? false : true;
  }

  const showNextStep = (step = null) => {

    if(consultationSection.id != 'consultation-in-section') {
      window.scrollTo({ top: 0, behavior: "smooth" });
      consultationSection.querySelector('.consultation-saved').classList.add('active');
      setTimeout(()=>{
        consultationSection.querySelector('.consultation-saved').classList.remove('active');
      },2000);
    }

    if(step == 'thankyou') {
      consultationSection.querySelector(`.consultation-step.active`).classList.remove('active');
      consultationSection.querySelector(`.consultation-step.consultation-step-thanks`).classList.add('active');
      fadeElementIn(consultationSection.querySelector(`.consultation-step.consultation-step-thanks`));
      updateProgressBar(consultationSteps.length);
      updateAdditionalPanels(consultationSteps.length);
      showResults();
    } else {
    
      if(!validateStep()) {
        return false;
      }

      // show next step
      let currentStep = consultationSection.querySelector('.consultation-step.active');
      let nextStep = parseInt(currentStep.dataset.step) + 1;

      if(consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`) || nextStep > consultationSection.querySelectorAll('.consultation-step').length) {
        let step_answer = false;
        if(currentStep.querySelector('.selectable-field-option input:checked')) {
          step_answer = currentStep.querySelector('.selectable-field-option input:checked').value;
        } else if(currentStep.querySelector('.consultation-step-icon.active')) {
          step_answer = currentStep.querySelector('.consultation-step-icon.active').dataset.selection;
        } else if (currentStep.querySelector('.payment-option.selected')) {
          step_answer = currentStep.dataset('.payment-option.selected').dataset.payment;
        } else if (currentStep.dataset.tag == 'Information') {
          consultation_data.information = true;
        }

        console.log(step_answer);

        if(consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`)) {
          consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`).classList.add('active');
          fadeElementIn(consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`));
          currentStep.classList.remove('active');
          updateProgressBar(nextStep);
          updateAdditionalPanels(nextStep);

          console.log('consultation_data.wearable',consultation_data.wearable);
          if(consultationSection.querySelector(`.consultation-step.active[data-tag="home_device"]`) && consultation_data.wearable) {
            consultationSection.querySelector(`.consultation-step.active[data-tag="home_device"] .consultation-step-icon[data-selection="${consultation_data.wearable}"]`).click();
          }

          if(nextStep > 1) {
            toggleBackBtn('show');
          }
        }

        sendConsultationDataLayerEvent(
          parseInt(nextStep),
          'cons_step_submit', 
          currentStep.dataset.tag, 
          false,
          step_answer,
          false
        );

        if(nextStep > consultationSection.querySelectorAll('.consultation-step').length || 
           consultationSection.querySelector(`.consultation-step[data-step="${nextStep}"]`).dataset.tag == 'thankyou') {
          consultation_data.is_completed = true;
          showResults();
          
        } else {

          postConsultationUserData(consultation_data)
          .then(res => console.log('Success:', res))
          .catch(err => console.error('Error:', err.message));
        }
      }

      
    }
  }

  const showPreviousStep = () => {
    if(!consultationSection.id) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    let currentStep = consultationSection.querySelector('.consultation-step.active');
    let previousStep = parseInt(currentStep.dataset.step) - 1;

    sendConsultationDataLayerEvent(
      parseInt(previousStep),
      'cons_other_event', 
      consultationSection.querySelector(`.consultation-step[data-step="${previousStep}"]`).dataset.tag, 
      'Navigate Back', 
      false,
      false
    );

    consultationSection.querySelector(`.consultation-step[data-step="${previousStep}"]`).classList.add('active');
    currentStep.classList.remove('active');
    updateProgressBar(previousStep);
    updateAdditionalPanels(previousStep);

    //consultationNextBtn.style.display = 'block';
    if(previousStep == 1) {
      toggleBackBtn('hide');
    }

    postConsultationUserData(consultation_data)
    .then(res => console.log('Success:', res))
    .catch(err => console.error('Error:', err.message));
  }

  const markSelection = (ev) => {
    let currentStep = consultationSection.querySelector('.consultation-step.active');

    // to check if v4 needs commended code below
    /*if(!ev.currentTarget.classList.contains('step-home')) {
      currentStep.querySelector('.consultation-step-icon.active')?.classList.remove('active');
    }

    if(ev.currentTarget.dataset.selection.indexOf('home') >= 0) {
      consultationHomeSelection.classList.add('visible');
      consultationHomeSelection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else if (ev.currentTarget.classList.contains('step-home')) {
      consultationHomeSelection.querySelector('.consultation-step-icon.active')?.classList.remove('active');
    } else {
      consultationHomeSelection.classList.remove('visible');
    }*/

    currentStep.querySelector('.consultation-step-icon.active')?.classList.remove('active');
    ev.currentTarget.classList.add('active');
    if (ev.currentTarget.classList.contains('step-home')) {
      currentStep.querySelector('.step-home-trigger').dataset.selection = `home,${ev.currentTarget.dataset.selection}`;
    }
    /* if button hidden - proceed to next step 
    if(consultationNextBtn.checkVisibility() == false && currentStep.dataset.tag != 'Payment') {
      consultationNextBtn.click();
      console.log(currentStep.dataset.tag);
    }*/
  }

  const getRecommendation = () => {
    let recommendation  = false;

    window.consultation_results.forEach((result) => {
      if(result.tags.indexOf(consultation_data.lifestyle) >= 0 && result.tags.indexOf(consultation_data.wearable) >= 0) {
        recommendation = result.product;
      }
    });

    return recommendation;
  }

  const showResults = () => {

    let recommendation = getRecommendation();
    
    if(recommendation) {
      consultation_data.recommendation = recommendation;
    }
    if(consultation_data.recommendation) {

      if(consultation_data.id && consultation_data.is_completed) {
        postConsultationUserData(consultation_data)
        .then(res => console.log('Success:', res))
        .catch(err => console.error('Error:', err.message));
      }

      storeSelection(consultation_data.recommendation);

      console.log('recommendation', recommendation);

      let additionalData = {
        relationship: consultation_data.relationship,
        cons_funnel_number: window.cons_funnel_number,
        payment: consultation_data.payment,
        first_name: consultation_data.first_name,
        surname: consultation_data.surname,
        type: consultation_data.type,
        lead_id: consultation_data.id
      }
  
      storeAdditionalSelection(JSON.stringify(additionalData));

      if(consultationStepThanks) {
        consultationNextBtn.style.display = 'none';
        if(consultationRecommentationBtn) {
          consultationRecommentationBtn.href = `/products/${consultation_data.recommendation}`;
        }

      } else {
        //alert(`/products/${consultation_data.recommendation}?rel=${consultation_data.relationship}`);
        window.location.href = `/products/${consultation_data.recommendation}?rel=${consultation_data.relationship}`;
      }
    }

  }

  const restartConsultation = () => {
    if(confirm('Are you sure you want to restart?')) {
      sendConsultationDataLayerEvent(
        'last', 
        'consultation_interaction', 
        'Recommendation Page', 
        're_take', 
        false
      );
      removeStoredSelection();
      document.location = `${document.location.origin}${document.location.pathname}`;
    }
  }

  const revealHiddenFields = (ev) => {
    if(ev.currentTarget.querySelector('input[type="radio"]:checked')){
      ev.currentTarget.closest('.consultation-step-fields').querySelectorAll('.selectable-field-hidden').forEach((hiddenField) => {
        hiddenField.classList.add('visible');
      });
    }
  }

  const postConsultationUserData = async (data) => {

    console.log(data);

    if (!Shopify.designMode) {
    
      try {
        console.log(JSON.stringify(data));
        const response = await fetch('https://customer-central-source.careline-app.co.uk/genesys/online-lead', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        if (response.status === 422) {
          throw new Error('Invalid ID: The provided ID does not exist.');
        }
        if (response.status === 500) {
          throw new Error('Server error: Something unexpected happened.');
        }
        if (!response.ok) {
          throw new Error(`Unexpected error: ${response.status}`);
        }

        const result = await response.json();
        return result;

      } catch (error) {
        console.error('POST request failed:', error.message);
        throw error;
      }

    }
    
  }

  const updateConsultationConsent = (e) => {
    if (e.target.checked) {
      if(e.target.id == 'consent-email') {
        consultation_data.consent_email = true;
      } else if(e.target.id == 'consent-sms') {
        consultation_data.consent_sms = true;
      }
    } else {
      if(e.target.id == 'consent-email') {
        consultation_data.consent_email = false;
      } else if(e.target.id == 'consent-sms') {
        consultation_data.consent_sms = false;
      }
    }
  }

  const updateConsultationPaymentOption = (e) => {
    console.log(e);
    if(e.currentTarget.classList.contains('selected') && e.target.classList.contains('button')) {
      console.log('next step');
      consultation_data.payment = e.currentTarget.dataset.payment;
      consultationNextBtn.click();
    } else if (!e.currentTarget.classList.contains('selected')) {
      consultationPaymentOptions.forEach((consultationPaymentOption) => {
        consultationPaymentOption.classList.remove('selected');
      });
      e.currentTarget.classList.add('selected');
    }
  }

  const initAccordions = () => {
    consultationSection.querySelectorAll('.alternative-accordion h4,.side-info-accordion h4').forEach((toggle) => {
      toggle.addEventListener('click', () => {
          const description = toggle.nextElementSibling;

          if (!toggle.classList.contains('active')) {
              toggle.classList.add('active');
              description.classList.add('is-open');
          } else {
              toggle.classList.remove('active');
              description.classList.remove('is-open');
          }
      });
    });
	};

  const addConsultationEvents = () => {
    consultationSelections.forEach((consultationIcon) => {
      consultationIcon.addEventListener('click', markSelection);
    });
    consultationCloseBtn?.addEventListener('click', closeConsultation);
    consultationNextBtn.addEventListener('click', showNextStep);
    consultationNextBtnMobile?.addEventListener('click', showNextStep);
    consultationPrevBtn.addEventListener('click', showPreviousStep);
    
    consultationSelectableFields.forEach((consultationSelectableField) => {
        consultationSelectableField.addEventListener('click', revealHiddenFields);
    });

    consultationConsents.forEach((consultationConsent) => {
        consultationConsent.addEventListener('change', updateConsultationConsent);
    });

    consultationPaymentOptions.forEach((consultationPaymentOption) => {
        consultationPaymentOption.addEventListener('click', updateConsultationPaymentOption);
    });

    if(consultationRestartBtn) {
      consultationRestartBtn.addEventListener('click', restartConsultation);
    }

    const handleAlternativeLifestyle = (selector, activeSelection, newSelection, addHomeOption) => {
      const element = consultationSection.querySelector(selector);
      if (!element) return;

      element.addEventListener('click', () => {
        console.trace(`${selector} clicked`);
        consultationSection.querySelector(`.consultation-step-icon.active[data-selection="${activeSelection}"]`).classList.remove('active');
        consultationSection.querySelector(`.consultation-step-icon[data-selection="${newSelection}"]`).classList.add('active');
        consultation_data.lifestyle = newSelection;
        consultationSection.querySelector('.consultation-step.active').classList.toggle('home-option', addHomeOption);
        window.scrollTo({ top: 0, behavior: "smooth" });

        postConsultationUserData(consultation_data)
          .then(res => console.log('Success:', res))
          .catch(err => console.error('Error:', err.message));
      });
    };

    handleAlternativeLifestyle('.view-alternative-home', 'home', 'roam', false);
    handleAlternativeLifestyle('.view-alternative-roam', 'roam', 'home', true);

  }

  const sendConsultationDataLayerEvent = (step, event, title, action, answer, result) => {

    //console.log(consultation_data);

    try {
      if(step == 'first') {
        title = false;
        window.cons_step = 0;
      } else if(step == 'last') {
          window.cons_step = window.cons_step ? window.cons_step+1 : 1;
      } else if(step > window.cons_step) {
        window.cons_step++;
      } else if(step < window.cons_step) {
         window.cons_step--;
      }
  
      window.cons_funnel_number++;

      let cons_event = {
        'event': event,
        'cons_type': 'Consultation Flow v2', 
        'cons_funnel_number': window.cons_funnel_number
      }

      if(window.cons_step > 0){
        cons_event.cons_step_number = window.cons_step;
      }

      if(title) {
        cons_event.cons_step_name = title;
      }

      if(action) {
        cons_event.cons_other_action = action;
      }
  
      if(answer) {
        cons_event.cons_answer = answer;
      } else if(result) {
        cons_event.cons_result = result;
      } 
  
      console.log(cons_event);
  
      dataLayer.push(cons_event);  
    } catch (error) {
      console.error(error);
    }
  }

  const updatePrices = () => {
      consultationSection.querySelectorAll('[data-price]').forEach(price => {
          if(consultationSection.querySelector('.vat-box .variant-radio.selected')) {
              price.innerText = price.dataset.price;
          } else {
              price.innerText = price.dataset.priceVat;
          }
      });
      document.querySelectorAll('.evernear-popup-modal [data-price]').forEach(price => {
          if(consultationSection.querySelector('.vat-box .variant-radio.selected')) {
              price.innerText = price.dataset.price;
          } else {
              price.innerText = price.dataset.priceVat;
          }
      });
  }

  const getBundleComponents = (handle) => {
    const query = `
        query ProductBundleComponents($handle: String!) {
                        product(handle: $handle) {
                            id
                            title
                            variants(first: 20) {
                                nodes {
                                    id
                                    title
                                    requiresComponents
                                    components(first: 20) {
                                        nodes {
                                            quantity
                                            productVariant {
                                                id
                                                title

                                                sellingPlanAllocations(first: 10) {
                                                    nodes {
                                                        sellingPlan {
                                                            id
                                                            name
                                                            recurringDeliveries
                                                        }
                                                    }
                                                }

                                            product {
                                                    id
                                                    title
                                                    handle
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
        `;

    fetch('/api/2026-04/graphql.json', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'cdb80b3d2229be2f10e09eb8210b2b38'
        },
        body: JSON.stringify({
            query,
            variables: {
                handle
            }
        })
    })
    .then(response => response.json())
    .then(data => {

      console.log(data);

        if(handle == window.product_json.handle) {
            const fetched_bundle_variants =
            data?.data?.product?.variants?.nodes || [];

            window.product_json.variants.forEach((variant, index) => {
                variant.bundle_variants = [];
                variant.selling_plans = []; // new selling plans
                fetched_bundle_variants.forEach(fetched_variant => {
                    if(fetched_variant.id.indexOf(variant.id) > 0) {
                        console.log('in if');
                        let variant_components = fetched_variant.components?.nodes || [];
                        variant_components.forEach(variant_component => {
                            variant.bundle_variants.push(variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''));
                            if(variant_component.productVariant.sellingPlanAllocations.nodes.length > 0 && variant_component.productVariant.sellingPlanAllocations.nodes?.[0].sellingPlan?.id) {
                                variant.selling_plans.push({'variant_id': variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''), 'selling_plan_id' : variant_component.productVariant.sellingPlanAllocations.nodes?.[0].sellingPlan.id.replace('gid://shopify/SellingPlan/','')}); // new selling plans
                            }
                        });
                    }
                });
            });

            //updateFooter();
        } else {
            const fetched_bundle_vat_variants =
            data?.data?.product?.variants?.nodes || [];

            window.product_json_vat.variants.forEach((variant, index) => {
                variant.bundle_variants = [];
                variant.selling_plans = []; // new selling plans
                fetched_bundle_vat_variants.forEach(fetched_variant => {
                    if(fetched_variant.id.indexOf(variant.id) > 0) {
                        console.log('in if');
                        let variant_components = fetched_variant.components?.nodes || [];
                        variant_components.forEach(variant_component => {
                            variant.bundle_variants.push(variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''));
                            if(variant_component.productVariant.sellingPlanAllocations.nodes.length > 0 && variant_component.productVariant.sellingPlanAllocations.nodes?.[0].sellingPlan?.id) {
                                variant.selling_plans.push({'variant_id': variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''), 'selling_plan_id' : variant_component.productVariant.sellingPlanAllocations.nodes?.[0].sellingPlan.id.replace('gid://shopify/SellingPlan/','')}); // new selling plans
                            }
                        });
                    }
                });
            });

            //updateFooter();
        }
        
    })
    .catch(error => {
        console.error('GraphQL error:', error);
    });
  }

  const vatOptions = () => {

      getBundleComponents(window.product_json_vat.handle);

      const updateVat = () => {
          consultationSection.querySelector('.vat-box .variant-radio').classList.toggle('selected');

          if(consultationSection.querySelector('.vat-box .variant-radio.selected')) {
              localStorage.removeItem('vatCheckbox', false); 
              localStorage.setItem('consultation-data',window.product_json.handle);
          } else {
              localStorage.setItem('vatCheckbox', false); 
              localStorage.setItem('consultation-data',window.product_json.handle);
          }
          
          updatePrices();
          //updateFooter();
      }

      consultationSection.querySelector('.vat-box .variant-radio').addEventListener('click', updateVat);

      if(localStorage.getItem('vatCheckbox') == 'false') {
          consultationSection.querySelector('.vat-box .variant-radio').click();
      }
  }

  const initCheckout = () => {

    getBundleComponents(window.product_json.handle);

    const replaceCartWithSellingPlan = async (items, checkout_data) => {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items
          })
        });

        console.log(items);
        console.log(checkout_data);
        window.location.href = `/checkout?${checkout_data}`;
    }
    
    const createPermalink = () => {
                
      window.bundle_to_add = '';
      window.product_json_to_add = window.product_json;
      if(!consultationSection.querySelector('.vat-box .variant-radio.selected')) {
          window.product_json_to_add = window.product_json_vat;
      }
      
      window.product_json_to_add.variants.forEach((variant) => {
                    
        if(variant.title.toLowerCase() == consultationSection.querySelector('.payment-option.selected').dataset.payment) {
            // new selling plans
            let items = [];
            let checkout_data = '';

            if(variant.bundle_variants && variant.bundle_variants.length > 0) {
              
              variant.bundle_variants.forEach(bundle_item => {
                let item = {
                  quantity: 1
                };
                item.id = bundle_item
                
                if(window.add_subscription_plan && variant.selling_plans && variant.selling_plans.length > 0 && variant.selling_plans[0].variant_id == bundle_item) {
                  item.selling_plan = variant.selling_plans[0].selling_plan_id;
                }

                items.push(item);

                if(window.bundle_to_add != '') {
                    window.bundle_to_add += ',';
                }
                window.bundle_to_add += bundle_item;
              });
            }

            checkout_data = `checkout[email]=${consultation_data.email}&checkout[shipping_address][first_name]=${consultation_data.first_name}&checkout[shipping_address][last_name]=${consultation_data.surname}`;

            replaceCartWithSellingPlan(items, checkout_data);

            //document.location = permalink;
          }
        });
      }

    const checkout = (ev) => {
      ev.preventDefault();
      ev.currentTarget.disabled = true;
      window.localStorage.setItem('bundle_added', window.bundle_to_add);

      consultation_data.payment = consultationSection.querySelector('.payment-option.selected').dataset.payment;
      consultation_data.is_completed = true;

      postConsultationUserData(consultation_data)
      .then(res => {
        consultation_data.id = res.id;
        console.log('Success:', res);
      })
      .catch(err => console.error('Error:', err.message));


      setTimeout(function(){
          createPermalink();
      },100);
    }

    const checkoutBtn = consultationSection.querySelector('#checkout');
    checkoutBtn.addEventListener('click', checkout);

  }

  const startconsultation = () => {
    window.cons_funnel_number = 0;
    updateProgressBar(1);
    updateAdditionalPanels(1);
    fadeElementIn(consultationSection.querySelector('.consultation-step[data-step="1"]'));
    addConsultationEvents();
    initAccordions();

    const params = new URLSearchParams(window.location.search);
    const consultation_type = params.get('type');

    console.log(consultation_type);
    console.log(decodeURIComponent(consultation_type));
    console.log(document.querySelector(`#relationship-field input[value="${decodeURIComponent(consultation_type)}"]`));

    if (consultation_type) {
      if(consultation_type.toLowerCase().indexOf('quick') >= 0) {
        consultationSection.classList.add('is-quick-version');
      }
      
      /*if (document.querySelector(`#relationship-field input[value="${decodeURIComponent(first_question)}"]`)) {
        document.querySelector(`#relationship-field input[value="${decodeURIComponent(first_question)}"]`).click();
      }*/
    } else {
      document.querySelector(`#relationship-field input[value="Unknown"]`)?.click();
    }

    postConsultationUserData(consultation_data)
    .then(res => {
      consultation_data.id = res.id;
      console.log('Success:', res);
    })
    .catch(err => console.error('Error:', err.message));

    sendConsultationDataLayerEvent(
      'first', 
      'cons_start', 
      consultationSection.querySelector('.consultation-step[data-step="1"]').dataset.tag, 
      false, 
      false,
      false
    );

    const replaceTitleTMs = () => {
      document.querySelectorAll(`.consultation .consultation-step-heading`).forEach((title) => {
          title.innerHTML = title.innerHTML.replace(
              /™/g,
              '<span class="tm">™</span>'
              );
      });
    }

    replaceTitleTMs();

    if(consultationSection.id && consultationSection.id == 'consultation-in-section') {
      document.querySelector('a[href="#consultation-in-section"]')?.addEventListener('click', (e) => {
        e.preventDefault();
        let offsetTop = 150;
        if(window.innerWidth < 750) {
          offsetTop = 90;
        }
        window.scrollTo({
            top: consultationSection.getBoundingClientRect().top + window.scrollY - offsetTop,
            behavior: 'smooth'
        });
      });
      
      vatOptions();
      initCheckout();
    }
  }

  if(getStoredSelection() != false) {
    console.log('stored',getStoredSelection());
    //consultation_data.recommendation = getStoredSelection();
    //addConsultationEvents();

    if(consultation_data.recommendation && consultationStepThanks) {
      showNextStep('thankyou');
      if(consultationRestartBtn) {
        consultationRestartBtn.style.display = 'inline-flex';
      }
    } else {
      startconsultation();
    }

  } else {
    startconsultation();
  }
}

initConsultation();

